import React from 'react';
import { Button, Table } from 'antd';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';

import { groupBy } from '../../../utils/collection';
import { sortByFields } from '../sort';
import DeleteButton from '../../common/DeleteButton';

const prepareColumns = (onUpdate, onDelete, onRestore, hasPermission) => {
  return [
    {
      title: 'User ID',
      dataIndex: 'userId',
      key: 'userId',
    },
    {
      title: 'Permissions',
      key: 'permissions',
      render: (text, record) => <div>{record.permissions.join(', ')}</div>,
    },
    {
      title: 'Groups',
      key: 'groups',
      render: (text, record) => <div>{record.groups.join(', ')}</div>,
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <div style={{ display: 'flex' }}>
          <Button
            data-test="edit-user_button"
            className="square-icon-button"
            style={{ border: '1px solid transparent', backgroundColor: 'transparent' }}
            onClick={() => onUpdate(record)}
          >
            <EditOutlined />
          </Button>
          <DeleteButton onDelete={() => onDelete(record.userId)}>
            <div>
              Are you sure to permanently delete{' '}
              <span style={{ fontWeight: 'bold' }}>{record.userId}</span>?
            </div>
          </DeleteButton>
        </div>
      ),
      permission: true,
    },
  ].filter((item) => (hasPermission ? true : !item.permission));
};

export const prepareDataSource = (users) => {
  const tempUsers = [...users].map((user) => ({ ...user, key: user.userId }));
  const separatedArr = groupBy(
    tempUsers,
    (item) => (/^[a-z]/i.test(item.userId) ? 'startsWithoutSymbol' : 'startsWithSymbol'),
    { startsWithoutSymbol: [], startsWithSymbol: [] }
  );

  sortByFields(separatedArr.startsWithoutSymbol, 'userId', 'permissions', 'groups');
  sortByFields(separatedArr.startsWithSymbol, 'userId', 'permissions', 'groups');

  return separatedArr.startsWithoutSymbol.concat(separatedArr.startsWithSymbol);
};

// TODO: very similar to segments table
const UsersTablePane = ({ onAdd, onUpdate, onDelete, onRestore, users, hasPermission }) => {
  const renderFooter = () => (
    <div>
      <Button onClick={() => onAdd()} disabled={!hasPermission}>
        <PlusOutlined />
        Add user
      </Button>
    </div>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
      <div style={{ display: 'flex', alignItems: 'flexStart', marginBottom: 16 }}>
        {/* <Input
     placeholder="Search by name"
     value={filterValue || ''}
     onChange={(e) => onFilterValueChange(e.target.value)}
     style={{width: 150}}
     /> */}
      </div>
      <Table
        columns={prepareColumns(onUpdate, onDelete, onRestore, hasPermission)}
        dataSource={prepareDataSource(users)}
        size="middle"
        pagination={{ defaultPageSize: 20, showSizeChanger: true }}
        style={{ marginBottom: 16 }}
        footer={renderFooter}
      />
    </div>
  );
};

export default UsersTablePane;
